import { Typography } from "@mui/material";
import type { FC } from "react";

export const NoTaskTextTip: FC = () => (
  <Typography variant="h6" textAlign="center" color="warning" fontWeight="bold">
    还没有任务记录，快去创建一个吧！
  </Typography>
);
